import React from 'react';
import blog from "../../../consumers/blog";
import BlogSection from "./BlogSection";

class BlogMain extends BlogSection {

    componentDidMount() {
        const blogNode = this.props.reference;
        if (blogNode) {
            blogNode.limitToLast(3).once('value').then(this.postsHandler);
        }
    }

}

export default blog(BlogMain);



// WEBPACK FOOTER //
// ./src/visitors/subscribers/blog/BlogMain.js